import {t} from 'i18next';
import {Box, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import './StandardIndexHeader.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {useDispatch} from 'react-redux';
import {setTabValue} from '../../../../../redux/slice/createCustomIndexSlice';

const StandardIndexHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleExit = () => {
    navigate('/Ingestion/Analytics');
    setTimeout(() => {
      dispatch(setTabValue(2));
    }, 200);
    return;
  };

  return (
    <Box className="standard-index-header">
      <Typography
        className="typo-text headline2_size standard-index-header-title"
        data-testid="standard-index-header-title"
      >
        {t('indexManagement.standardIndex.title')}
      </Typography>
      <Box className="standard-index-header-button-section">
        <ArrButton
          variant="secondary"
          size="small"
          onClick={handleExit}
          className="standard-index-exit-button"
          dataTestId="standard-index-header-exit-button"
        >
          <Typography className="exit-text">
            {t('indexManagement.customIndex.exit')}
          </Typography>
        </ArrButton>
      </Box>
    </Box>
  );
};

export default StandardIndexHeader;
